let vibe_cake_masters_scroll_to = function( $ ) {

	let $links,
		anim_speed = 600;

	let _init = function() {
		$links = $( '.cake-masters-component.scroll-to-link' );

		if ( $links.length > 0 ) {
			_setup_links();
		}
	};

	let _setup_links = function() {
		$links.not( '.setup-scroll-to' ).each( ( index, item ) => {
			let $link = $( item );

			$link.on( 'click', function( e ) {
				e.preventDefault();

				_scroll_to( $( $( this ).attr( 'href' ) ) );
			} );

			$link.addClass( 'setup-scroll-to' );
		} )
	};

	let _scroll_to = function( $elem ) {
		if ( $elem.length === 1 ) {
			$( 'html, body' ).animate( {
				scrollTop : $elem.offset().top
			}, anim_speed );
		}
	};

	$( document ).ready( _init );

} ( jQuery );

module.exports = vibe_cake_masters_scroll_to;